import { render } from "./externalCredentials.vue?vue&type=template&id=738ade0e&scoped=true"
import script from "./externalCredentials.vue?vue&type=script&lang=js"
export * from "./externalCredentials.vue?vue&type=script&lang=js"

import "./externalCredentials.vue?vue&type=style&index=0&id=738ade0e&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738ade0e"]])

export default __exports__